// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"754054b0","799":"e1b08fd4"}[chunkId] + ".chunk.js";
};